export default __webpack_public_path__ + "static/ProValue_5-0aa951ef014e6fb95b97ea0e0430e5a5.png";